import React from "react";
import LoginLink from "./LoginLink";
interface Props {
  loginOverride: boolean;
}
const EmailInstantlyForPrice = ({
  loginOverride
}: Props) => {
  return <p className="price enter-email" data-sentry-component="EmailInstantlyForPrice" data-sentry-source-file="EmailInstantlyForPrice.tsx">
      {loginOverride ? <>
          <LoginLink>Login</LoginLink> or enter your email to be instantly sent
          the price!
        </> : <>Enter your email to be instantly sent the price!</>}
    </p>;
};
export default EmailInstantlyForPrice;